import {
  getLocalizedTime,
  getRelativeDate,
} from "@/playground/components/DevHome/table/utilities/date";
import type { CellProps } from "./Cell.decl";

// dev-only: CC reads the locale from the dashboard-extension host context
// (@dashboard/extension), which assets-page does not have. Hardcode en-US.
const language = "en-US";

export function Cell({ date }: CellProps) {
  return (
    <div className="flex flex-col w-[80px]">
      <span className="text-sm font-medium">
        {getLocalizedTime(date, language)}
      </span>
      <span className="text-xs font-medium text-muted-foreground">
        {getRelativeDate(date, language)}
      </span>
    </div>
  );
}
